var SpotModel = require("./SpotModel");

/**
 * AppointmentModel
 *
 * @param {object} data the FlexAppointment data
 */
function FlexAppointmentModel(data) {
  this.id = data.id;
  this.queueId = data.queueId;

  this.location = {
    id: data.locationId,
    description: data.locationName || "",
  };

  this.resource = {
    id: data.resourceId,
    description: data.resourceDescription || ""
  };

  this.serviceDuration = data.serviceDuration;
  
  this.transaction = {
    type: data.transactionType,
    description: data.transactionTypeDescription || ""
  };

  this.status = data.status;
  this.start = data.startDateTime;
  this.end = data.endDateTime;

  this.consumer = Object.assign({
    phone: "",
    lastName: "",
    firstName: "",
    email: "",
  }, data.consumer);

  this._createSpot();

  // NB Used computed observables to "bind" this
  this.isRejected = ko.computed(this._isRejected, this)
  this.appointmentTime = ko.computed(this._appointmentTime, this)
}

FlexAppointmentModel.prototype._createSpot = function() {
  this.spot = new SpotModel(this.consumer);
  this.spot.queueId = this.queueId;
  this._updateSpotName();
};

FlexAppointmentModel.prototype._updateSpotName = function() {
  var hasName = this.consumer.firstName || this.consumer.lastName;
  if (hasName && this.spot) {
    var consumerName =
      this.consumer.firstName && this.consumer.lastName
        ? this.consumer.firstName + " " + this.consumer.lastName
        : this.consumer.firstName || this.consumer.lastName;
    this.spot.name(consumerName);
  }
};

FlexAppointmentModel.prototype.withSpot = function (spot) {
  this.spot = spot;
  this.spot.queueId = this.queueId;
  this._updateSpotName();
}

FlexAppointmentModel.prototype._isRejected = function() {
  var STATUS_REJECTED = "REJECTED";
  var STATUS_REJECTED_EXPLICITLY = "REJECTED_EXPLICITLY";
  return (this.status === STATUS_REJECTED || this.status === STATUS_REJECTED_EXPLICITLY)
}

FlexAppointmentModel.prototype._appointmentTime = function () {
  var time = new Date(Date.parse(this.start));
  var localeTime = time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  return localeTime;
};

if (typeof exports !== "undefined") {
module.exports = FlexAppointmentModel;
}
